export enum BookingStatus {
  NEW = 'new',
  CONFIRMED = 'confirmed',
  CANCELLED = 'cancelled',
  COMPLETED = 'completed',
}

export interface Booking {
  id: number;
  client: number;
  client_name: string;
  client_phone: string;
  car: number;
  car_title: string;
  license_plate?: string;
  start_date: string;
  end_date: string;
  status: BookingStatus;
  status_display: string;
  deposit_amount: string;
  rental_amount: string;
  notes: string;
  created: string;
  modified: string;
}

export interface BookingList {
  id: number;
  client_name: string;
  client_phone: string;
  car_title: string;
  license_plate?: string;
  start_date: string;
  end_date: string;
  status: BookingStatus;
  deposit_amount: string;
  rental_amount: string;
}

export interface BookingCreate {
  client: number;
  car: number;
  start_date: string;
  end_date: string;
  status?: string;
  deposit_amount?: string;
  rental_amount?: string;
  notes?: string;
}

export interface DashboardStats {
  new_bookings: number;
  confirmed_bookings: number;
  issued_rentals: number;
  free_cars: number;
}